import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import Main from "./components/layout/Main";
import Login from "./pages/login/LoginPage";
import CreteItems from "./pages/Store/CreateBooking/CreateBooking";


import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import BookingView from "./pages/Store/Bookings/BookingView";
import BookingReport from "./pages/Store/Bookings/BookingReport";
import HotelAgentManagement from "./pages/Store/Bookings/HotelAgentManagement";
import Cookies from "js-cookie";


function App() {
  let rememberedUser = Cookies.get("rememberedUser");
  const is_cookie_set = Boolean(rememberedUser);

  let ROLE1 = "USER";

  if (rememberedUser) {
    rememberedUser = JSON.parse(rememberedUser);
    const { ROLE } = rememberedUser;
    ROLE1 = ROLE;
  }

  useEffect(() => {
    if (is_cookie_set && window.location.pathname === '/') {
      // Redirect to '/' if no valid cookie is set and the path is not '/'
      window.location.href = "/bookings";
    }
  }, [is_cookie_set]);

  return (
      <div className="App">
        <Switch>
          <Route path="/" exact component={Login} />
          <Main>
            <Route exact path="/bookings" component={BookingView} />
            <Route exact path="/sign-up" component={SignUp} />
            <Route exact path="/profile" component={Profile} />
            <Route exact path="/add-booking" component={CreteItems} />
            <Route exact path="/booking-report" component={BookingReport} />
            <Route exact path="/hotel-agent-management" component={HotelAgentManagement} />
            {/*<Route exact path="/add-transactions" component={AddTransactionForm} />*/}
            {/*<Route exact path="/customers-store1" component={Customers} />*/}
            {/*<Route exact path="/edit-transactions" component={EditTransactions} />*/}
            {/*<Route exact path="/make-juice" component={MakeJuice} />*/}
            {/*<Route exact path="/ice-creames" component={IceCream} />*/}
            {/*<Route exact path="/reports" component={Reports} />*/}
            {/*<Route exact path="/return" component={Return} />*/}
            {/*<Route exact path="/add-payments-store1" component={AddPaymentsForm} />*/}
            {/*<Redirect to="/bookings" />*/}
          </Main>
        </Switch>
      </div>
  );
}

export default App;
